import Vue from 'vue'
// import Vuex from 'vuex'
import Router from 'vue-router'

// Containers
import DefaultContainer from '@/containers/DefaultContainer'

// Views
import Dashboard from '@/views/Dashboard'
import Newport from '@/views/Newport'

// import Colors from '@/views/theme/Colors'
// import Typography from '@/views/theme/Typography'

import Charts from '@/views/Charts'
// import Widgets from '@/views/Widgets'

// Views - Components
import Locks from '@/views/base/Locks'
import LockDetail from '@/views/base/haus/LockDetail'

// import Cards from '@/views/base/Cards'
import Forms from '@/views/base/Forms'
// import Switches from '@/views/base/Switches'
import EkeyList from '@/views/base/haus/EkeyList'
import EkeyForm from '@/views/base/haus/EkeyForm'
import EkeyEditForm from '@/views/base/haus/EkeyEditForm'
import PasscodeList from '@/views/base/haus/PasscodeList'

import Manager from '@/views/base/Manager'
import ManagerForm from '@/views/base/ManagerForm'
import ManagerList from '@/views/base/ManagerList'
import ManagerListDetail from '@/views/base/ManagerListDetail'
import LockGroup from '@/views/base/LockGroup'
// import AssignLocation from '@/views/base/forms/AssignLocation'
import LockGroupForm from '@/views/base/LockGroupForm'
import LockGroupListDetails from '@/views/base/LockGroupListDetails'
import ManagerAddForm from '@/views/base/ManagerAddForm'
// import ManagerMoveForm from '@/views/base/ManagerMoveForm'
import LockToLockGroupMapperForm from '@/views/base/LockToLockGroupMapperForm'
import Location from '@/views/base/Location'
import LocationForm from '@/views/base/LocationForm'
import LocationAddForm from '@/views/base/LocationAddForm'
import LockCard from '@/views/base/haus/LockCard'
import HistoryList from '@/views/base/haus/HistoryList'
import LocationListAddLock from '@/views/base/haus/LocationListAddLock'
import LockgroupListAddLock from '@/views/base/haus/LockgroupListAddLock'
import Statistics from '@/views/base/haus/Statistics'

import LocksUnassigned from '@/views/base/LocksUnassigned'
import PasscodeForm from '@/views/base/haus/PasscodeForm'
import ManagerListForLock from '@/views/base/haus/ManagerListForLock'
// import LocksBackup from '@/views/base/LocksBackup'
import LockGroupFormAndList from '@/views/base/haus/LockGroupFormAndList'
import AllLocks from '@/views/base/haus/AllLocks'
import ManagerForLocation from '@/views/base/haus/ManagerForLocation'
import UserProfile from '@/views/base/haus/UserProfile'
import AssignHausType from '@/views/base/intern/AssignHausType'
import ManagerStatus from '@/views/base/intern/ManagerStatus'
// import Tables from '@/views/base/Tables'
// import Tabs from '@/views/base/Tabs'
// import Breadcrumbs from '@/views/base/Breadcrumbs'
// import Carousels from '@/views/base/Carousels'
// import Collapses from '@/views/base/Collapses'
// import Jumbotrons from '@/views/base/Jumbotrons'
// import ListGroups from '@/views/base/ListGroups'
// import Navs from '@/views/base/Navs'
// import Navbars from '@/views/base/Navbars'
// import Paginations from '@/views/base/Paginations'
// import Popovers from '@/views/base/Popovers'
// import ProgressBars from '@/views/base/ProgressBars'
// import Tooltips from '@/views/base/Tooltips'

// Views - Buttons
// import StandardButtons from '@/views/buttons/StandardButtons'
// import ButtonGroups from '@/views/buttons/ButtonGroups'
// import Dropdowns from '@/views/buttons/Dropdowns'
// import BrandButtons from '@/views/buttons/BrandButtons'

// Views - Icons
// import Flags from '@/views/icons/Flags'
// import FontAwesome from '@/views/icons/FontAwesome'
// import SimpleLineIcons from '@/views/icons/SimpleLineIcons'
// import CoreUIIcons from '@/views/icons/CoreUIIcons'

// Views - Notifications
// import Alerts from '@/views/notifications/Alerts'
// import Badges from '@/views/notifications/Badges'
// import Modals from '@/views/notifications/Modals'

// Views - Pages
import Page404 from '@/views/pages/Page404'
import Page500 from '@/views/pages/Page500'
import Login from '@/views/pages/Login'
import Register from '@/views/pages/Register'

// Vue.use(vuex)
Vue.use(Router)

export default new Router({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'open active',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [{
    path: '/',
    redirect: 'Newport',
    auth: true,
    name: 'Home',
    component: DefaultContainer,
    children:
    [{
      path: 'newport/:locationId?',
      name: 'Newport',
      component: Newport
    }, {
      path: 'base',
      redirect: '/base/locks',
      name: 'Base',
      component: {
        render (c) {
          return c('router-view')
        }
      },
      children: [{
        path: 'locks',
        name: 'Locks',
        component: Locks
      },
      {
        path: 'locksUnassigned',
        name: 'LocksUnassigned',
        component: LocksUnassigned
      },
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard
      },
      {
        path: 'lockDetail/:lockId',
        name: 'LockDetail',
        component: LockDetail
      },
      {
        path: 'manager',
        name: 'Manager',
        component: Manager
      },
      {
        path: 'managerform',
        name: 'ManagerForm',
        component: ManagerForm
      },
      {
        path: 'managerlist',
        name: 'ManagerList',
        component: ManagerList
      },
      {
        path: 'managerlistdetail/:id',
        name: 'ManagerListDetail',
        component: ManagerListDetail
      },
      {
        path: 'lockGroup',
        name: 'LockGroup',
        component: LockGroup
      },
      {
        path: 'lockGroupForm',
        name: 'LockGroupForm',
        component: LockGroupForm
      },
      {
        path: 'lockGroupEditForm/:id',
        name: 'LockGroupEditForm',
        component: LockGroupForm
      },
      {
        path: 'lockGroupListDetails/:id',
        name: 'LockGroupListDetails',
        component: LockGroupListDetails
      },
      {
        path: 'managerAddForm',
        name: 'ManagerAddForm',
        component: ManagerAddForm
      },
      {
        path: 'lockToLockGroupMapperForm',
        name: 'LockToLockGroupMapperForm',
        component: LockToLockGroupMapperForm
      },
      {
        path: 'forms',
        name: 'Forms',
        component: Forms
      },
      {
        path: 'locations',
        name: 'Location',
        component: Location
      },
      {
        path: 'locationform',
        name: 'LocationForm',
        component: LocationForm
      },
      {
        path: 'addlocation',
        name: 'LocationAddForm',
        component: LocationAddForm
      },
      {
        path: 'charts',
        name: 'Charts',
        component: Charts
      },
      {
        path: 'ekeylist/:lockId',
        name: 'EkeyList',
        component: EkeyList
      },
      {
        path: 'ekeyForm/:lockId',
        name: 'EkeyForm',
        component: EkeyForm
      },
      {
        path: 'passcodeForm/:lockId',
        name: 'PasscodeForm',
        component: PasscodeForm
      },
      {
        path: 'ekeyEditForm/:id',
        name: 'EkeyEditForm',
        component: EkeyEditForm
      },
      {
        path: 'passcodeList/:lockId',
        name: 'PasscodeList',
        component: PasscodeList
      },
      {
        path: 'lockCard',
        name: 'LockCard',
        component: LockCard
      },
      {
        path: 'historyList/:lockId',
        name: 'HistoryList',
        component: HistoryList
      },
      {
        path: 'locationListAddLock/:lockId',
        name: 'LocationListAddLock',
        component: LocationListAddLock
      },
      {
        path: 'lockgroupListAddLock/:lockId',
        name: 'LockgroupListAddLock',
        component: LockgroupListAddLock
      },
      {
        path: 'statistics',
        name: 'Statistics',
        component: Statistics
      },
      {
        path: 'managerListForLock/:lockId',
        name: 'ManagerListForLock',
        component: ManagerListForLock
      },
      {
        path: 'lockGroupFormAndList',
        name: 'LockGroupFormAndList',
        component: LockGroupFormAndList
      },
      {
        path: 'allLocks',
        name: 'AllLocks',
        component: AllLocks
      },
      {
        path: 'managerForLocation',
        name: 'ManagerForLocation',
        component: ManagerForLocation
      },
      {
        path: 'userprofile',
        name: 'UserProfile',
        component: UserProfile
      },
      {
        path: 'assignHausType',
        name: 'AssignHausType',
        component: AssignHausType
      },
      {
        path: 'managerStatus',
        name: 'ManagerStatus',
        component: ManagerStatus
      }

      ]
    }]
  },
  {
    path: '/pages',
    redirect: '/pages/404',
    name: 'Pages',
    component: {
      render (c) {
        return c('router-view')
      }
    },
    children: [{
      path: '404',
      name: 'Page404',
      component: Page404
    },
    {
      path: '500',
      name: 'Page500',
      component: Page500
    },
    {
      path: 'login',
      name: 'Login',
      component: Login
    },
    {
      path: 'register',
      name: 'Register',
      component: Register
    }]
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js